import ApiService from '../api.service'
import getCurrentCompanyId from '../company.service'

export interface ICreateShiftPayload {
  name: string
  start_time: string
  end_time: string
  group_ids?: number[]
}

export interface IUpdateShiftPayload extends ICreateShiftPayload {
  id: number
}

const ShiftResource = {
  getShifts: () => ApiService.get(`v1/companies/${getCurrentCompanyId()}/shifts`),
  show: (id: number) => ApiService.get(`v1/companies/${getCurrentCompanyId()}/shifts/${id}`),
  create: (params: ICreateShiftPayload) => ApiService.post(`v1/companies/${getCurrentCompanyId()}/shifts`, params),
  update: (params: IUpdateShiftPayload) => ApiService.put(`v1/companies/${getCurrentCompanyId()}/shifts/${params.id}`, params),
  delete: (id: number) => ApiService.delete(`v1/companies/${getCurrentCompanyId()}/shifts/${id}`),
}

export default ShiftResource
